var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 217,
    height: 103,
    viewBox: "0 0 217 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-401 30.98C-401 30.98 -357.351 3 -305.868 3C-254.385 3 -241.514 30.98 -192.269 30.98C-143.025 30.98 -122.879 3 -76.9918 3C-31.1046 3 -17.1146 30.98 26.5341 30.98C70.1829 30.98 94.8053 3 140.133 3C185.46 3 214 30.98 214 30.98",
    stroke: "white",
    strokeWidth: 4.02357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-401 58.96C-401 58.96 -357.351 30.98 -305.868 30.98C-254.385 30.98 -241.514 58.96 -192.269 58.96C-143.025 58.96 -122.879 30.98 -76.9918 30.98C-31.1046 30.98 -17.1146 58.96 26.5341 58.96C70.1829 58.96 94.8053 30.98 140.133 30.98C185.46 30.98 214 58.96 214 58.96",
    stroke: "white",
    strokeWidth: 4.02357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-401 86.94C-401 86.94 -357.351 58.96 -305.868 58.96C-254.385 58.96 -241.514 86.94 -192.269 86.94C-143.025 86.94 -122.879 58.96 -76.9918 58.96C-31.1046 58.96 -17.1146 86.94 26.5341 86.94C70.1829 86.94 94.8053 58.96 140.133 58.96C185.46 58.96 214 86.94 214 86.94",
    stroke: "white",
    strokeWidth: 4.02357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-401 44.4104C-401 44.4104 -357.351 16.4304 -305.868 16.4304C-254.385 16.4304 -241.514 44.4104 -192.269 44.4104C-143.025 44.4104 -122.879 16.4304 -76.9918 16.4304C-31.1046 16.4304 -17.1146 44.4104 26.5341 44.4104C70.1829 44.4104 94.8053 16.4304 140.133 16.4304C185.46 16.4304 214 44.4104 214 44.4104",
    stroke: "white",
    strokeWidth: 4.02357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-401 72.3904C-401 72.3904 -357.351 44.4104 -305.868 44.4104C-254.385 44.4104 -241.514 72.3904 -192.269 72.3904C-143.025 72.3904 -122.879 44.4104 -76.9918 44.4104C-31.1046 44.4104 -17.1146 72.3904 26.5341 72.3904C70.1829 72.3904 94.8053 44.4104 140.133 44.4104C185.46 44.4104 214 72.3904 214 72.3904",
    stroke: "white",
    strokeWidth: 4.02357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-401 100.37C-401 100.37 -357.351 72.3904 -305.868 72.3904C-254.385 72.3904 -241.514 100.37 -192.269 100.37C-143.025 100.37 -122.879 72.3904 -76.9918 72.3904C-31.1046 72.3904 -17.1146 100.37 26.5341 100.37C70.1829 100.37 94.8053 72.3904 140.133 72.3904C185.46 72.3904 214 100.37 214 100.37",
    stroke: "white",
    strokeWidth: 4.02357,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteWaves);
export default __webpack_public_path__ + "static/media/white-waves.b243d8d4.svg";
export { ForwardRef as ReactComponent };